import React, { useState, useEffect } from "react";
import {
  Box, Typography, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, CircularProgress, Button,
} from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useGetAmTeamMutation } from "state/api";
import { toast } from "react-toastify";
import foliregLogo  from "../../assets/Folireg.png";
import bisberryLogo from "../../assets/Bisberry.png";
import endocareLogo from "../../assets/Endocare.png";
import lycoredLogo  from "../../assets/Lycored-M.png";

const BrandHeader = ({ logo, label }) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
    <Box component="img" src={logo} alt={label}
      sx={{ height: 18, width: "auto", objectFit: "contain" }} />
    <span>{label}</span>
  </Box>
);

const MrList = () => {
  const { user } = useSelector((s) => s.auth);
  const navigate = useNavigate();
  const [getAmTeam] = useGetAmTeamMutation();
  const [team, setTeam] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user?.role) {
      setLoading(true);
      getAmTeam({ MgCd: user.role })
        .unwrap()
        .then(setTeam)
        .catch((err) => toast.error(err?.data?.message || "Failed to load team"))
        .finally(() => setLoading(false));
    }
  }, [user, getAmTeam]);

  if (loading) return <Box sx={{ display: "flex", justifyContent: "center", py: 5 }}><CircularProgress /></Box>;

  return (
    <Box>
      <Typography variant="h5" fontWeight={700} gutterBottom>My Team MRs</Typography>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>EmpNo</TableCell>
              <TableCell><BrandHeader logo={foliregLogo}  label="Folireg Rx" /></TableCell>
              <TableCell><BrandHeader logo={bisberryLogo} label="Bisberry Weekly" /></TableCell>
              <TableCell><BrandHeader logo={endocareLogo} label="Endocare PSP" /></TableCell>
              <TableCell><BrandHeader logo={lycoredLogo}  label="Lycored M" /></TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {team.map((mr) => (
              <TableRow key={mr.EmpNo}>
                <TableCell>{mr.name}</TableCell>
                <TableCell>{mr.EmpNo}</TableCell>
                <TableCell>{mr.rx_count}</TableCell>
                <TableCell>{mr.weekly_count}</TableCell>
                <TableCell>{mr.psp_count}</TableCell>
                <TableCell>{mr.lycored_count}</TableCell>
                <TableCell>
                  <Button size="small" variant="outlined" onClick={() => navigate(`/am/mr-details/${mr.MgCd}`)}>
                    View
                  </Button>
                </TableCell>
              </TableRow>
            ))}
            {team.length === 0 && (
              <TableRow><TableCell colSpan={7} align="center">No MRs found in your team</TableCell></TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default MrList;
